document.addEventListener("DOMContentLoaded", () => {
  const resourcesTag = document.getElementById("compare-resources");
  if (resourcesTag) {
    const resources = JSON.parse(resourcesTag.textContent);
    resources.forEach((resource) => {
      if (resource.type === "js") {
        const script = document.createElement("script");
        script.src = resource.path;
        document.head.appendChild(script);
      } else if (resource.type === "css") {
        const link = document.createElement("link");
        link.href = resource.path;
        link.type = "text/css";
        link.rel = "stylesheet";
        document.head.appendChild(link);
      }
    });
    resourcesTag.remove();
  }

  const productList = document.querySelector("#main-content");

  if (!productList) {
    console.error("Product list not found!");
  } else {
    // より詳細な監視設定
    const config = {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    };

    let isProcessing = false; // 重複実行防止

    const initializeCompareFeatures = () => {
      if (isProcessing) return;
      isProcessing = true;

      // 既存のイベントリスナーを削除して重複を防ぐ
      const existingCheckboxes = document.querySelectorAll(".boost-sd__product-item__compare");
      existingCheckboxes.forEach(element => {
        element.replaceWith(element.cloneNode(true));
      });

      // 新しいイベントリスナーを設定
      const checkboxCompare = document.querySelectorAll(".boost-sd__product-item__compare");
      if (checkboxCompare.length > 0) {
        checkboxCompare.forEach(function (element) {
          element.addEventListener("click", function (e) {
            e.stopImmediatePropagation();
          });
        });

        // DOMの更新完了を待つ
        requestAnimationFrame(() => {
          if (typeof CompareUtil !== 'undefined' && CompareUtil.updateCompareCheckboxes) {
            CompareUtil.updateCompareCheckboxes();
          }
          isProcessing = false;
        });
      } else {
        isProcessing = false;
      }

      // compare switch custom
      const compareToggle = document.getElementById("compare-switch");
      const compareButton = document.getElementById("compare-drawer-open");
      const products = document.querySelector(".boost-sd__product-list");

      if (compareToggle && !compareToggle.hasAttribute('data-initialized')) {
        compareToggle.setAttribute('data-initialized', 'true');

        function toggleCompare(evt, persist = true) {
          const isChecked = compareToggle.classList.contains("is-active");

          if (evt) {
            compareToggle.classList.toggle("is-active");
          }

          const newIsChecked = compareToggle.classList.contains("is-active");

          if (compareButton) {
            if (!newIsChecked) {
              compareButton.classList.add("is-out");
              if (products) products.classList.remove("is-show-compare");
            } else {
              compareButton.classList.remove("is-out");
              if (products) products.classList.add("is-show-compare");
            }
          }

          if (persist && typeof Shopify !== 'undefined' && !Shopify.designMode) {
            if (typeof theme !== 'undefined' && theme.storageUtil) {
              theme.storageUtil.set("compare-toggle", newIsChecked);
            }
          }
        }

        compareToggle.addEventListener("click", toggleCompare);

        // 初期状態の設定
        if (typeof theme !== 'undefined' && theme.storageUtil) {
          const isChecked = theme.storageUtil.get("compare-toggle", true);
          if (isChecked !== null) {
            if (isChecked) {
              compareToggle.classList.add("is-active");
              if (compareButton) compareButton.classList.remove("is-out");
            }
            toggleCompare(null, true);
          } else {
            toggleCompare(null, false);
          }
        }
      }
    };

    const callback = (mutationList, observer) => {
      let shouldUpdate = false;

      for (const mutation of mutationList) {
        // 商品リストに関連する変更を検知
        if (mutation.type === 'childList' &&
            (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {

          // 商品アイテムが含まれる変更かチェック
          const hasProductItems = Array.from(mutation.addedNodes).some(node =>
            node.nodeType === Node.ELEMENT_NODE &&
            (node.classList?.contains('boost-sd__product-item') ||
             node.querySelector?.('.boost-sd__product-item'))
          );

          if (hasProductItems) {
            shouldUpdate = true;
            break;
          }
        }
      }

      if (shouldUpdate) {
        // DOM更新の完了を少し待ってから処理実行
        setTimeout(initializeCompareFeatures, 100);
      }
    };

    // フィルターボタンの処理
    const toggleButton = document.querySelector(".c_boost-sd__filter-button");
    const targetElement = document.getElementById("boost-sd-filter-tree-column");

    if (toggleButton && targetElement) {
      toggleButton.addEventListener("click", () => {
        targetElement.style.display = targetElement.style.display === "none" ? "" : "none";
      });
    }

    // 初期化実行
    initializeCompareFeatures();

    // オブザーバー開始
    const observer = new MutationObserver(callback);
    try {
      observer.observe(productList, config);
    } catch (error) {
      console.error("Observer failed:", error);
    }
  }
});

// フィルターの項目クリック時にURL遷移
// document.addEventListener("DOMContentLoaded", () => {
//   setTimeout(() => {
//     const items = document.querySelectorAll(
//       '.boost-sd__filter-option[data-filteroptionid="pf_c_kategori"] .boost-sd__filter-option-item button'
//     );

//     // NodeList の長さをチェック
//     if (!items || items.length === 0) {
//       console.log("対象の要素が見つかりませんでした");
//       return;
//     }

//     console.log("items:", items);

//     items.forEach(el => {
//       el.addEventListener("click", () => {
//         console.log("現在のURL:", window.location.href);
//         setTimeout(() => {
//           // ページをリロード
//           window.location.href = window.location.href;
//         }, 500);
//       });
//     });
//   }, 2000);
// });

(() => {
  const TARGET = '.boost-sd__filter-option[data-filteroptionid="pf_c_kategori"] .boost-sd__filter-option-item button';
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(TARGET);
    if (!btn) return;

    const before = location.href;
    setTimeout(() => {
      const now = location.href;
      if (now !== before) {
        window.location.href = now;
      } else {
        window.location.reload();
      }
    }, 100);
  });
})();